<template>
  <div class="email-app-details view-new">
    <!-- Email Header -->
    <!-- <div class="email-detail-header">
      <div class="email-header-left d-flex align-items-center">
        <h4 class="email-subject mb-0">
          {{ newsViewData.title }}
        </h4>
      </div>
    </div> -->
    <template v-if="newsViewData._id || newsViewData.draftId">
      <news-action-button
        instance='0'
        :newsData="newsViewData"
        :event_status="newsViewData.event_status"
        @action-edit="$emit('action-edit', newsViewData)"
        @action-publish="$emit('action-publish', newsViewData)"
        @action-store="$emit('action-store', newsViewData)"
        @action-schedule="openScheduleModal"
        @action-copy="$emit('action-copy', newsViewData)"
        @action-cancel="$emit('action-cancel', newsViewData)"
        @action-disable="$emit('action-disable', newsViewData)"
        @action-errata="$emit('action-errata', newsViewData, true)"
        @close="$emit('close')"
        @reindex-news="$emit('reindex-news', newsViewData)"
        @refresh-news="$emit('refresh-news', newsViewData)"
        @remove-elastic-from="$emit('remove-elastic-from', newsViewData)"
        @restore-elastic="$emit('restore-elastic', newsViewData)"
        @vectorize-news="$emit('vectorize-news', newsViewData)"
      ></news-action-button>
      <!-- Email Details -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="email-scroll-area scroll-area"
      >
        <!-- <span class="go-back mr-1">
          <feather-icon
            icon="XIcon"
            size="20"
            class="align-bottom"
            @click="$emit('close-email-view')"
          />
        </span> -->

        <!-- News Body Content -->
        <b-row>
          <b-col cols="12">
            <manage-news-content-card
              :newsData="newsViewData"
              @download-document="onDownloadFile"
              @open-related-news="openRelatedNews"
              @open-news-view="openNewsView"
              @action-filter-subject="onFilterSubject"
              @action-filter-user="onFilterUser"
              @action-filter-origin="onFilterOrigin"
              @action-filter-important="onFilterImportant"
              @action-filter-inLive="onFilterInLive"
              @action-filter-flashes="onFilterFlashes"
              @action-edit="$emit('action-edit', newsViewData)"
              @action-publish="$emit('action-publish', newsViewData)"
              @action-store="$emit('action-store', newsViewData)"
              @action-copy="$emit('action-copy', newsViewData)"
              @action-cancel="$emit('action-cancel', newsViewData)"
              @action-errata="$emit('action-errata', newsViewData, true)"
              @open-document="openDocument"
            />
          </b-col>
        </b-row>

        <!-- User Action History -->
        <manage-news-status-hist
          v-if="newsViewData.event_status_hist.length > 0"
          :newsData="newsViewData"
        ></manage-news-status-hist>

        <!-- Processing Status Tracking -->
        <manage-news-processing-status
          :newsId="newsViewData._id ? newsViewData._id.toString() : null"
        />
      </vue-perfect-scrollbar>
    </template>
    <template v-else>
      <div class="selected-emp">
        <div class="message-emp">
          <span class="ilustration"
            ><img :src="require('@/assets/images/pages/report.svg')" /></span
          ><span>{{ $t('MANAGE_NEWS.NoSelectedNews') }}</span>
          <p>{{ $t('MANAGE_NEWS.NothingSelected') }}</p>
        </div>
      </div>
    </template>

    <nw-schedule-modal ref="manage-news-modal-scheduled" @submit="sendEventShedule" />
    <b-modal
      modal-class="modal-primary modal-pdf-viewer"
      :ref="`manage-news-pdf-viewer`"
      title="Visualizar"
      size="lg"
      centered
      no-close-on-backdrop
    >
      <PDFToolbar
        :scale="scaleMaximized"
        :isMaximize="true"
        :displayDownloadBtn="true"
        :newsViewData="newsViewData"
        @change="updateScalePdfView"
        @printPdf="printPdf"
        @download="onDownloadFile"
        class="header-item"
      />
      <pdf-viewer
        refs="pdf-viewer"
        v-if="hasPdf"
        :newsId="newsViewData._id"
        :url="newsViewData.document.image_path"
        :scale="scaleMaximized"
        @updateScaleViewerEvent="updateScalePdfView"
      ></pdf-viewer>
      <p v-if="!hasPdf">
        {{$t('PDF_VIEWER.NoPdf')}}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { BRow, BCol, BModal } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, watch } from "@vue/composition-api";
import ManageNewsContentCard from "./ManageNewsContentCard.vue";
import ManageNewsStatusHist from "./ManageNewsStatusHist.vue";
import NwScheduleModal from "../components/NwScheduleModal.vue";
import ManageNewsProcessingStatus from "./ManageNewsProcessingStatus.vue";
import NewsActionButton from "../NewsActionButton.vue";
import newsService from "@/providers/newsService";
import Ripple from "vue-ripple-directive";
import PDFToolbar from "@/views/pdf/PDFToolbar.vue";
import PdfViewer from "@/views/pdf/PdfViewer.vue";
import printJS from "print-js";
import AppConstants from '@/appConstants';

let that;

export default {
  directives: {
    Ripple,
  },
  created() {
    that = this;
  },
  components: {
    // BSV
    // BDropdown,
    // BDropdownItem,
    BRow,
    BCol,
    BModal,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ManageNewsContentCard,
    ManageNewsStatusHist,
    NwScheduleModal,
    ManageNewsProcessingStatus,
    NewsActionButton,
    PdfViewer,
    PDFToolbar,
  },
  props: {
    newsViewData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasPdf() {
      if (!this.newsViewData.document) return false;
      return this.newsViewData.document.extension == 'pdf';
    }
  },
  setup(props, context) {
    const scaleMaximized = ref(1.2);
    // const scaleMaximized = ref(2.5);
    // const scaleMinimized = ref(1.8);

    // O modal ja validou a data/hora (valida e futura) e fechou
    const sendEventShedule = ({ date, hour }) => {
      that.$emit("action-schedule", {
        _id: that.newsViewData._id,
        dt_scheduled: `${date} ${hour}`
      });
    };

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    const showContentCard = ref(false);

    watch(
      () => props.newsViewData._id,
      () => {
        showContentCard.value = true;
      }
    );

    const openScheduleModal = () => {
      // Aqui so noticia armazenada pode ser agendada: o dt_scheduled que sobrar e de um agendamento antigo
      that.$refs[`manage-news-modal-scheduled`].show(
        props.newsViewData.event_status == AppConstants.EVENT_STATUS.SCHEDULED ? props.newsViewData.dt_scheduled : null
      );
    };

    const onDownloadFile = () => {
      const params = new URLSearchParams();
      params.append("download", true);

      newsService
        .downloadDocumentFile(props.newsViewData._id, params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", props.newsViewData.document.original_filename);
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const openRelatedNews = (item) => {
      context.emit('open-related-news', item);
    }
    const onFilterSubject = (item) => {
      context.emit('action-filter-subject', item);
    };
    const onFilterUser = (item) => {
      context.emit('action-filter-user', item);
    };
    const onFilterOrigin = (item) => {
      context.emit('action-filter-origin', item);
    };
    const onFilterImportant = (item) => {
      context.emit('action-filter-important', item);
    };
    const onFilterInLive = (item) => {
      context.emit('action-filter-inLive', item);
    };
    const onFilterFlashes = (item) => {
      context.emit('action-filter-flashes', item);
    };



    const openDocument = () => {
      that.$refs[`manage-news-pdf-viewer`].show();
    };

    const updateScalePdfView = (scale) => {
      scaleMaximized.value = scale;
      console.log('updateScalePdfView:', scale);
      // this.scaleMaximized = scale;
    };
    
    const openNewsView = (item) => {
      console.log('openNewsManageNewsView:');
      context.emit("open-news-view", item);
    };

    const printPdf = () => {
      const params = new URLSearchParams();
      newsService
        .readDocumentFile(props.newsViewData._id, params)
        .then((response) => {
          const bytes = that.$CryptoJS.AES.decrypt(
            response.data,
            AppConstants.PDF_PWD
          );
          const plain = bytes.toString(that.$CryptoJS.enc.Utf8);
          printJS({ printable: plain, type: props.newsViewData.document.extension, base64: true});
        })
        .catch((error) => {
          console.log(error);
        });
    }


    return {
      scaleMaximized,

      // UI
      perfectScrollbarSettings,
      showContentCard,

      // METHODS
      onDownloadFile,
      openRelatedNews,
      sendEventShedule,
      openScheduleModal,
      onFilterSubject,
      onFilterUser,
      onFilterOrigin,
      onFilterImportant,
      onFilterInLive,
      onFilterFlashes,
      updateScalePdfView,
      openDocument,
      printPdf,
      openNewsView
    };
  },
};
</script>

<style>
</style>
